<template>
  <header class="header">
    <nav class="navbar navbar-default no_margin">
      <div class="container-fluid">
        <div class="navbar-header">
          <span class="navbar-brand" v-if="this.ml">&nbsp;代理后台管理系统&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span class="navbar-brand" v-if="this.xx">
            <i class="iconfont icon-shijian"></i>
            {{date|datefmt("HH:mm")}}
          </span>
        </div>
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <div class="siteletter_outer" @mouseenter="mEnter" @mouseleave="mLeave" >
            <div class="noticelabel">站内信：</div>
            <div  class="nonotice"   v-if="siteletterlist.length==0">暂无新通知</div>
            <ul class="siteletter" ref="scrollItemBox" :style="{ transform: `translate(0px,-${scrollTop}px)` }">
              <li    @click="showdetail(item)" v-for="(item,index) in siteletterlist"   :key="index">
                <p>{{item.Title}}</p>
                <!-- <div class="closebox"><i class="el-icon-close"></i></div> -->
              </li>
            </ul>
          </div>
          <ul class="nav navbar-nav navbar-right">
            <li>
              <a href="javascript:;"><span style="display: inline-block;overflow: hidden;">机构名称：</span>
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">{{$store.state.InsName}}</div>
                <span class="username space" style="width: 48px">{{$store.state.InsName}}</span>
              </el-tooltip></a>
            </li>
            <li>
              <a href="javascript:;" style="color:#fff !important; display:inline-block;"><span style="display: inline-block;overflow: hidden;">欢迎您，</span>
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">{{$store.state.userInfo.AccountName}}</div>
                <span class="username space">{{$store.state.userInfo.AccountName}}</span>
              </el-tooltip>
              </a>

            </li>
            <li>
              <a href="javascript:;" style="padding:10px 25px 5px 0px;">
                <div class="profile_info"><img src="../assets/images/profile.jpg" alt="暂无图片" class="profile_info_tx"></div>
              </a>
            </li>
            <li class="dropdown">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                <span class="fa fa-user"></span>个人中心
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu dropdown-menus">
                <li @click="setpswd()">
                  <a href="javascript:;" class="setpsw">
                    <span class="fa fa-pencil-square-o"></span>&nbsp;修改密码</a>
                </li>
                <li @click="OpenIpwhiteDialog()">
                    <a href="javascript:;">
                      <span class="fa fa-pencil-square-o"></span>&nbsp;IP白名单</a>
                  </li>
              </ul>
            </li>
            <li @click="exit()">
              <a href="javascript:;" style="color:#fff !important;">
                <span class="fa fa-power-off"></span> 退出 </a>
            </li>
            <li>
              <a href="javascript:;"></a>
            </li>
          </ul>
        </div>
        <el-dialog
          title="站内信详情"
          :visible.sync="dialogVisible"
          width="30%"
          :append-to-body="true"
          >
          <div>
              <p>标题：{{znxdatadetail.Title}}</p>
              <p>内容：{{znxdatadetail.Content}}</p>
              <p>备注：{{znxdatadetail.Remark}}</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title="IP白名单"
          :visible.sync="ipwhiteshow"
          width="40%"
          class="header-dialog" 
          :append-to-body="true"
          >
          
          <div>
            <div class="iptip">提示：多个IP以逗号间隔</div>
            <el-input v-model="IPwhiteStr" placeholder="请输入IP白名单，多个IP以逗号间隔" size="small"></el-input>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="ipwhiteshow = false">取 消</el-button>
            <el-button type="primary" @click="SetIPwhiteList()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="修改密码" class="header-dialog" :visible.sync="dialogFormVisible" :append-to-body="true" width="30%" @close="resetForm('ruleForm2')" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <el-form-item label="旧密码" prop="OldPwd">
              <el-input type="password" v-model.trim="ruleForm2.OldPwd  " auto-complete="off" size="small"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="NewPwd">
              <el-input type="password" v-model.trim="ruleForm2.NewPwd" auto-complete="off" placeholder="包含大小写字母及数字，长度不得小于8位！" size="small"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass" style="margin-bottom:0px;">
              <el-input type="password" v-model.trim="ruleForm2.checkPass" auto-complete="off" placeholder="请再次输入密码" size="small"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm2')" size="small">提交</el-button>
            <el-button @click="resetForm('ruleForm2')" size="small">重置</el-button>
          </div>
        </el-dialog>
      </div>
    </nav>
  </header>

</template>

<script>
import "../assets/lib/jquery.min.js";
let timer = null;
export default {
  name: "headers",
  data() {
    var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value == this.ruleForm2.OldPwd) {
        callback(new Error("新密码不能与旧密码相同！"));
      } else if (value.length < 8) {
        callback(new Error("新密码长度不能低于8位！"));
      } else if (!reg.test(value)) {
        callback(
          new Error("新密码必须包含大写字母,小写字母,数字,不能包含特殊符号！")
        );
      } else if (reg.test(value)) {
        if (this.ruleForm2.checkPass !== "") {
          this.$refs.ruleForm2.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm2.NewPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      scrollTop:0,
      speed: 15,
      loading: false,
      dialogFormVisible: false,
      IPwhiteStr:'',
      ipwhiteshow:false,
      date: "",
      Agentcode: "",
      ml: "",
      xx: false,
      type: "",
      userInfo: {
        NeedModifyPwd: ""
      },
      ruleForm2: {
        NewPwd: "",
        OldPwd: "",
        checkPass: ""
      },
      rules2: {
        NewPwd: [{ validator: validatePass, trigger: "blur", required: true }],
        checkPass: [
          { validator: validatePass2, trigger: "blur", required: true }
        ],
        OldPwd: [
          { trigger: "blur", required: true, message: "旧密码不能为空!" }
        ]
      },
      siteletterlist:[],
      dialogVisible:false,
      znxdatadetail:{},
      alreadyreadid:''
    };
  },
  created() {
    if (JSON.parse(sessionStorage.getItem('userInfo')) != null && JSON.parse(sessionStorage.getItem('userInfo')) !== '') {
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    }
    if (this.$Agentcode == "ml") {
      this.ml = true;
      this.xx = false;
    } else {
      this.xx = true;
      this.ml = false;
    }
    if (this.userInfo.NeedModifyPwd) { // 判断是否需要修改密码
      this.setpswd();
    }
    if(this.$route.path.indexOf("login") != -1 || this.$route.path.indexOf("forgetPswd") != -1 || this.$route.path.indexOf("iphonregister") != -1){
      this.$store.state.userInfo.AccountName = "暂无信息";
    }else{
       if(this.$store.state.userInfo.AccountName == undefined ||  this.$store.state.userInfo.AccountName == null || this.$store.state.userInfo.AccountName == "暂无信息"){
      this.$store.state.userInfo.AccountName = this.userInfo.AccountName;
      }
    }
    if(this.$store.state.islogin){
this.QryNotReadSiteLetterList(true);
    }

  },
  mounted() {
    var _this = this; //声明一个变量指向vue实例this,保证作用域一致
    this.timer = setInterval(function() {
      _this.date = new Date(); //修改数据date
    }, 1000);
    
  },
  watch:{
    $route(to,from){ // 判断是否需要修改密码
      if (to.name == 'forgetPswd' || from.name == 'forgetPswd' || to.name == "login") {
        return;
      }
      this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (this.userInfo.NeedModifyPwd) {
        this.setpswd();
      }
    }
   },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); //在vue实例销毁钱，清除我们的定时器
    }
  },
  methods: {
    showdetail(data){

          this.dialogVisible=true;
          this.znxdatadetail=data;
          this.alreadyreadid=data.ID;
          this.alreadyread()
      },
      //已读
     alreadyread(){
          let postdata=this.alreadyreadid;
          let url="/SiteLetter/ReadSiteLetter";
          let that=this;
          this.$loginapi.post(url, postdata, response => {
            if (response.Ret == 0) {
                that.QryNotReadSiteLetterList(false);
            } else {
              this.$message.error(response.Msg);
           }
          });
     },
   // 鼠标移入停止滚动
    mEnter() {

        clearInterval(timer);
      },
        // 鼠标移出继续滚动
    mLeave() {

      this.startScroll()
    },
    // 开始滚动
      startScroll() {
          timer = setInterval(this.scroll, 60);
      },
    scroll() {
      this.scrollTop++
      let scrollItemBox = this.$refs.scrollItemBox.offsetHeight;
      if (this.scrollTop >= scrollItemBox) {
            this.scrollTop = 0;
      }
    },
    //打开IP白名单弹窗
    OpenIpwhiteDialog(){
        this.ipwhiteshow=true;
        this.QueryIPwhiteList();
        
    },
    //查询ip白名单表格
    QueryIPwhiteList(){

      if (this.$store.state.islogin) {
          let postdata="";
          let url="/Account/QryIPWhiteList"
          
          this.$loginapi.post(url, postdata, response => {
            if (response.Ret == 0) {

                this.IPwhiteStr=response.Data;
                
            } else {
              this.$message.error(response.Msg);
           }
          });
          
        }
    },
    //设置IP白名单
    SetIPwhiteList(){
      let postdata=this.IPwhiteStr;
      let url="/Account/SetIPWhiteList"       
      this.$loginapi.post(url, postdata, response => {
      if (response.Ret == 0) {
          this.IPwhiteStr='';
          this.ipwhiteshow=false;
                this.$message.success('设置成功');
        } else {
          this.$message.error(response.Msg);
          }
        });
    },
    //获取站内信
    QryNotReadSiteLetterList(status){
            let postdata='';
            let url="/SiteLetter/QryNotReadSiteLetterList" 
            let that=this;      
            this.$loginapi.post(url, postdata, response => {
            if (response.Ret == 0) {
                this.siteletterlist=response.Data;
                  if(status){
                      that.mEnter();
                      that.startScroll()
                  }
              } else {
                this.$message.error(response.Msg);
                }
              });
    },
    exit() {
      var uname = sessionStorage.getItem("uname");
      var token = "token" + uname;
      var inscode = sessionStorage.getItem("inscode");
      sessionStorage.removeItem("uname");
      sessionStorage.removeItem("inscode");
      sessionStorage.removeItem("pwd");
      sessionStorage.removeItem(token);
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("type");
      this.$store.state.inscode = "";
      this.$store.state.uname = "";
      this.$store.state.pwd = "";
      this.$store.state.islogin = false;
      this.$store.state.userInfo = {};
      this.mEnter();
      this.$router.push("/login/" + inscode);
    },

    //修改密码
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.type == "0") {
            let url = "/common/ModifyAgentSelfPwd";
            let data = {
              NewPwd: this.ruleForm2.NewPwd,
              OldPwd: this.ruleForm2.OldPwd
            };
            this.loading = true;
            this.$loginapi.post(url, data, response => {
              this.loading = false;
              if (response.Ret == 0) {
                this.$alert("密码修改成功，请重新登录！", "", {
                  confirmButtonText: "确定",
                  callback: action => {
                    this.dialogFormVisible = false;
                    this.exit();
                  }
                });
              } else {
                this.$alert(response.Msg);
              }
            });
          } else {
            let url = "/AgentAccount/ModifyAgentAccountPassword";
            let data = {
              NewPassword: this.ruleForm2.NewPwd,
              OldPassword: this.ruleForm2.OldPwd
            };
            this.loading = true;
            this.$loginapi.post(url, data, response => {
              this.loading = false;
              if (response.Ret == 0) {
                this.$alert("密码修改成功，请重新登录！", "", {
                  confirmButtonText: "确定",
                  callback: action => {
                    this.dialogFormVisible = false;
                    this.exit();
                  }
                });
              } else {
                this.$alert(response.Msg);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    setpswd(){
      this.dialogFormVisible = true;  
      this.type = sessionStorage.getItem("type");
    }
  }
};
</script>

<style scoped>
.header .username {
  display: inline-block;
  width: 60px;
}
.header .space {
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.siteletter_outer{
  background-color: #fff;
  width: 300px;
  height: 30px;
  float: left;
  margin-left: 50px;
  margin-top: 10px;
  overflow: hidden;
  position: relative;
}
.siteletter{

  background-color: #fff;
  width: 400px;
  position: absolute;
  margin-bottom: 0;
  top: 0;
  /* animation: upupup 3s infinite; */
}
.siteletter li{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  width: 300px;
  padding-left: 70px;
  cursor: pointer;
}
.siteletter p{

  margin: 0;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 350px;
}
.closebox{

  font-size: 24px;
  margin-right: 10px;
}
.iptip{

  margin-bottom: 10px;
  font-weight: 700;
}
.noticelabel{

  position: absolute;
  left: 10px;
  z-index: 99;
  height: 30px;
  line-height: 30px;
}
.nonotice{
  text-align: left;
  height: 30px;
  line-height: 30px;
  padding-left: 70px;
}
.siteletter p{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue